export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '5be89da', dateTime: 1776197906107 };